import { Box, Typography, TextField, Button, Grid, IconButton, CircularProgress } from '@mui/material';
import COLORS from '../../../../../../constants/colors';
import { Facebook, Twitter, Instagram,LinkedIn } from '@mui/icons-material';
import { useState } from 'react'; // Import useState to manage form data
import baseURL from '../../../../user/config';
import SnackbarAlert from '../../../../user/Reusbale/SnackbarAlert';
import { toast } from 'react-toastify';
import { PrimaryButton } from '../../../../../Reusable/Button';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });
    const [loading, setLoading] = useState(false); // Track loading state
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Validate form data to ensure all fields are filled
        if (!formData.name || !formData.email || !formData.subject || !formData.message) {
            
            toast.error('Please fill in all fields.')
            return; // Prevent form submission if any field is empty
        }
    
        setLoading(true); // Show loader
        try {
            const response = await fetch(`${baseURL}/data/backend/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
    
            const result = await response.json();
            if (response.ok) {
              

            toast.success(result.message || 'Your message was sent successfully!')

    
                // Reset form data after successful submission
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    message: '',
                });
            } else {
                setSnackbar({
                    open: true,
                    message: result.message || 'There was an error sending your message.',
                    severity: 'error',
                });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setSnackbar({
                open: true,
                message: 'There was an error sending your message. Please try again later.',
                severity: 'error',
            });
        } finally {
            setLoading(false); // Hide loader
        }
    };
    

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <Box sx={{ py: 3, px: 3, maxWidth: 1200, margin: '0 auto', mt: 6 }}>
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={5}>
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h6" fontWeight="bold" color={COLORS.primary} mb={2} sx={{ fontSize: '2rem' }}>
                            We're Here to Help!
                        </Typography>
                        <Typography variant="body1" color={COLORS.text}>
                            Have any questions or feedback? Reach out to us, and we will get back to you as soon as possible.
                        </Typography>
                    </Box>

                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h6" fontWeight="bold" color={COLORS.primary} mb={2}>
                            Contact Information
                        </Typography>
                        <Typography variant="body1" color={COLORS.text} mb={1}>
                            <strong>Email:</strong> support@yambaafrica.com
                        </Typography>
                        <Typography variant="body1" color={COLORS.text} mb={1}>
                            <strong>Phone:</strong> 0752 627 003 / 0790 359 312
                        </Typography>
                    </Box>


<Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
  {[{
    href: 'https://www.linkedin.com/company/yamba-africa',
    icon: <LinkedIn />,
    label: 'LinkedIn'
  }, {
    href: 'https://x.com/yamba_africa',
    icon: <Twitter />,
    label: 'Twitter'
  }, {
    href: 'https://www.instagram.com/yamba_africa/',
    icon: <Instagram />,
    label: 'Instagram'
  }].map(({ href, icon, label }) => (
    <Box
      key={label}
      sx={{
        bgcolor: 'background.paper', // or any card bg color you want
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        p: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'scale(1.1)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        },
      }}
    >
      <IconButton
        color="accent"
        href={href}
        target="_blank"
        aria-label={label}
        sx={{ p: 0, color: 'inherit' }}
      >
        {icon}
      </IconButton>
    </Box>
  ))}
</Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
                        <TextField
                            label="Your Name"
                            variant="outlined"
                            fullWidth
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            sx={{
                                mb: 3,
                                borderRadius: '10px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                },
                            }}
                            InputLabelProps={{ style: { color: COLORS.primary } }}
                            InputProps={{
                                style: { color: COLORS.text },
                            }}
                        />
                        <TextField
                            label="Your Email"
                            variant="outlined"
                            fullWidth
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            sx={{
                                mb: 3,
                                borderRadius: '10px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                },
                            }}
                            InputLabelProps={{ style: { color: COLORS.primary } }}
                            InputProps={{
                                style: { color: COLORS.text },
                            }}
                        />
                        <TextField
                            label="Subject"
                            variant="outlined"
                            fullWidth
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            sx={{
                                mb: 3,
                                borderRadius: '10px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                },
                            }}
                            InputLabelProps={{ style: { color: COLORS.primary } }}
                            InputProps={{
                                style: { color: COLORS.text },
                            }}
                        />
                        <TextField
                            label="Your Message"
                            variant="outlined"
                            fullWidth
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            multiline
                            rows={6}
                            sx={{
                                mb: 3,
                                borderRadius: '10px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                },
                            }}
                            InputLabelProps={{ style: { color: COLORS.primary } }}
                            InputProps={{
                                style: { color: COLORS.text },
                            }}
                        />

                        <PrimaryButton type="submit"> 
                              {loading ? (
        <>
            <CircularProgress size={18} color="inherit" sx={{ marginRight: 1 }} />
            <Typography variant="body1" color={COLORS.white}>Please wait ..</Typography>
        </>
    ) : (
        'Send Message'
    )}
                        </PrimaryButton>


                    </Box>
                </Grid>
            </Grid>

            {/* Snackbar for success/error messages */}
            <SnackbarAlert
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                handleClose={handleCloseSnackbar}
            />
        </Box>
    );
};

export default ContactUs;
